var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c(_vm.ifNo,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c(_vm.ifYes,{tag:"component"},[(_vm.empty)?[_vm._v(" "+_vm._s(_vm.empty)+" ")]:[_vm._v(" - ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }